var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.42858 1C9.89781 1 11.334 1.43568 12.5557 2.25194C13.7773 3.0682 14.7294 4.22839 15.2917 5.58578C15.8539 6.94317 16.001 8.43681 15.7144 9.87781C15.4278 11.3188 14.7203 12.6425 13.6814 13.6814C12.6425 14.7203 11.3188 15.4278 9.87782 15.7144C8.43682 16.001 6.94318 15.8539 5.58578 15.2917C4.22839 14.7294 3.06821 13.7773 2.25195 12.5557C1.43568 11.334 1.00001 9.8978 1.00001 8.42857C0.99765 6.30054 1.81641 4.25365 3.28572 2.71429",
    stroke: "#1D3557",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.28627L3.28571 2.71484L3.85714 5.00056",
    stroke: "#1D3557",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42969 4.42871V9.00014L11.4011 10.4859",
    stroke: "#1D3557",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.ac64eb34afcaed35e1599204c8fded16.svg";
export { ForwardRef as ReactComponent };